import React from 'react';
import { Routes, Route } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import Layout from "../Layouts/index";

//routes
import {authProtectedRoutes, publicGeneralRoutes, publicRoutes} from "./allRoutes";
import { AuthProtected } from './AuthProtected';
import UiNotifications from "../Components/Common/UiNotifications";

const Index = () => {
    return (
        <React.Fragment>
            <Routes>
                <Route>
                    {publicRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                              <Layout>{route.component}</Layout>
                            }
                            key={idx}
                            exact={true}
                        />
                    ))}
                </Route>

                <Route>
                    {authProtectedRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <AuthProtected>
                                    <Layout>{route.component}</Layout>
                                </AuthProtected>}
                            key={idx}
                            exact={true}
                        />
                    ))}
                </Route>

              <Route>
                {publicGeneralRoutes.map((route, idx) => (
                  <Route
                    path={route.path}
                    element={
                      <NonAuthLayout>
                        {route.component}
                      </NonAuthLayout>
                    }
                    key={idx}
                    exact={true}
                  />
                ))}
              </Route>
            </Routes>
          <UiNotifications />
        </React.Fragment>
    );
};

export default Index;
